// GalleryPage.js
import React from 'react';
import ImageSlider from './ImageSlider'; // Import the ImageSlider component

const SliderWeek11 = ({ onImageIndexChange }) => {
  const slideImages = [
'https://res.cloudinary.com/ahbranding/image/upload/v1704371654/AHbranding/Slide_16_9_-_62_ojkdb8.png',
'https://res.cloudinary.com/ahbranding/image/upload/v1704371654/AHbranding/Slide_16_9_-_63_bvzass.png',
'https://res.cloudinary.com/ahbranding/image/upload/v1704371654/AHbranding/Slide_16_9_-_64_mp4fee.png',
'https://res.cloudinary.com/ahbranding/image/upload/v1720889254/AHbranding/Slide_16_9_-_66_mha857.png',
'https://res.cloudinary.com/ahbranding/image/upload/v1704371655/AHbranding/Slide_16_9_-_66_ed5foo.png',
'https://res.cloudinary.com/ahbranding/image/upload/v1704371654/AHbranding/Slide_16_9_-_68_owfseo.png',
'https://res.cloudinary.com/ahbranding/image/upload/v1704371657/AHbranding/Slide_16_9_-_67_orxtyk.png'

  ];

  const handleImageIndexChange = (index) => {
    if (onImageIndexChange) {
      onImageIndexChange(index);
    }
  };


  return (
    <div className="gallery-page">
      <ImageSlider className="w-full" onImageIndexChange={handleImageIndexChange} images={slideImages} /> {/* Integrate the ImageSlider component */}
    </div>
  );
};

export default SliderWeek11;
